<template>
    <div class="box">
        <span class="headline mb24" ref="getheight">奖励激活</span>
        <div class="Single" ref="getheight1">
            <div class="flexCenter">
                <el-input class="mr12" clearable v-model="page.search_name" @change="changeSearch_name" placeholder="搜索奖励码">
                </el-input>
                <!-- <input
                    class="input-file"
                    type="file"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    @change="exportData"
                /> -->
                <el-button class="input_button" size="mini" @click="leadingin">导入</el-button>
            </div>
        </div>

        <el-table :data="message" :max-height="height + 'px'" style="width: 100%">
            <el-table-column fixed="" label="激活时间" width="150" :render-header="renderPrice">
                <template slot-scope="scope">
                    {{ scope.row.active_time | formatOrdertime }}
                </template>
            </el-table-column>
            <el-table-column label="溯源码" max-width="150" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.label" placement="bottom">
                        <span class="v_tips">{{ scope.row.label }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="奖励码" max-width="150" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.red_envelope_label" placement="bottom">
                        <span class="v_tips">{{ scope.row.red_envelope_label }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="导入需要激活的溯源码" @close="close" :visible.sync="leading" width="648px" top="15vh" class="v_dol">
            <el-upload
                class="upload-demo"
                :limit="1"
                :http-request="btnClick"
                :file-list="fileList"
                action="https://jsonplaceholder.typicode.com/posts/"
                accept=".xls,.XLS,.xlsx,.XLSX"
                drag
            >
                <img src="../../assets/img/Vector.png" alt="" class="Vector" />
                <div class="el-upload__text">点击或拖动上传.excel</div>
                <div class="el-upload__tip" slot="tip">只能上传xls文件，且不超过500kb</div>
            </el-upload>
            <div class="dialog-footer">
                <el-button class="v_buttons" size="mini" @click="getupload">开始上传</el-button>
            </div>
        </el-dialog>
        <div class="notificationn notificationn_104" v-if="notificationns">
            <div class="notificationn_left"></div>
            <div>
                <div class="notificationn_title" v-if="code!=200">导入失败</div>
                <div class="notificationn_dec">{{ msg }}</div>
            </div>
        </div>
        <pagination :page="page" @getPage="getPage" @getNum="getNum"></pagination>
    </div>
</template>

<script>
import * as XLSX from 'xlsx';
export default {
    name: 'activation',
    data() {
        return {
            notificationns: false,
            fileList: [],
            leading: false,
            red_packet: [],
            page: {
                num: 10,
                page: 1,
                total: 0,
                search_name: ''
            },
            message: [],
            height: '',
            code:0,
        };
    },

    mounted() {
        window.screenHeight = document.body.clientHeight;
        this.screenHeight = window.screenHeight;
        this.height = this.screenHeight - this.$refs.getheight.offsetHeight - this.$refs.getheight1.offsetHeight - 85 - 24 - 14 - 40;
        this.getMessage(); //获取列表
    },
    methods: {
        renderPrice(h, { column, $index }) {
            const styleFilter = {
                fontSize: '16px',
                fontWeight: 'bold',
                marginLeft: '8px'
            };
            return [
                column.label,
                h(
                    'i',
                    [
                        h('span', {
                            class: { 'el-icon-bottom': true },
                            style: {
                                ...styleFilter //设置样式
                            }
                        })
                    ] // 图标
                )
            ];
        },
        getMessage() {
            let that = this;
            let obj = {
                page: that.page.page,
                num: that.page.num
            };
            if (that.page.search_name) {
                obj.search_name = that.page.search_name;
            }
            that.$get('/backapi/red_label', obj).then(function (res) {
                if (res.count) {
                    console.log(res.data);
                    that.page.total = res.count;
                    that.message = res.data;
                } else {
                    that.page.total = 0;
                    that.message = [];
                }
            });
        },
        getPage(e) {
            this.page.page = e;
            this.getMessage();
        },
        getNum(e) {
            this.page.num = e;
            this.page.page = 1;
            this.getMessage();
        },
        // 搜索溯源码
        changeSearch_name(e) {
                this.page.search_name = e;
                this.page.num = 10;
                this.page.page = 1;
            this.getMessage(); //获取列表
        },
        // 导入
        leadingin() {
            this.leading = true;
        },
        // 关闭
        close() {
            this.leading = false;
            this.fileList = [];
            this.arr = [];
        },
        handleChange(file, fileList) {
            this.fileList = fileList;
        },
        btnClick(event) {
            let arr = [];
            let that = this;
            let file = event.file; // 拿到文件信息
            if (!file) {
                return false;
            } else if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
                // 这里格式根据自己需求定义
                this.$message.error('格式错误，请上传xls或者xlsx格式');
                return false;
            }
            const fileReader = new FileReader();
            fileReader.onload = (ev) => {
                try {
                    const data = ev.target.result;
                    const workbook = XLSX.read(data, {
                        // 以字符编码方式解析
                        type: 'binary'
                    });
                    // 获取第一张表
                    const exlname = workbook.SheetNames[0];
                    const exl = XLSX.utils.sheet_to_json(workbook.Sheets[exlname]); // 生成json表格内容
                    that.red_packet = exl;
                    that.getPick();
                } catch (e) {
                    return false;
                }
            };

            fileReader.readAsBinaryString(file);
        },
        getPick() {
            let that = this;
            const newArr = that.red_packet.map((item) => item.溯源码);
            const str = newArr.join(',') + ',';
            const flag = newArr.some((item) => {
                return str.replace(item + ',', '').indexOf(item + ',') > -1;
            });
            if (flag) {
                that.msg = '出现重复导入';
                that.leading = false;
                that.fileList = [];
                that.notificationns = true;
                setTimeout(() => {
                    that.notificationns = false;
                }, 3000);
                return;
            }
            let arr = [];
            that.red_packet.map((item) => {
                item = item.溯源码
                arr.push(item.toString());
            });
            that.arr = arr;
        },
        // 上传
        getupload() {
            let that = this;
            if (that.red_packet.length == 0) {
                that.$message.error({
                    message:'请上传文件'
                })
                return;
            }
            console.log(that.arr);
            let obj = {
                label_list_str: JSON.stringify(that.arr) 
            };
            that.$put('/backapi/label_package', obj)
                .then(function (res) {
                    console.log(res);
                   
                    if (res.code == 200) {
                         that.code=res.code
                        that.msg = '导入成功';
                        that.notificationns = true;
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                        that.getMessage();
                        that.close();
                    } else {
                        that.msg = res.msg;
                        that.notificationns = true;
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);

                        that.close();
                    }
                })
                .catch((err) => {
                    that.close();
                });
        }
    }
};
</script>

<style scoped>
.el-upload__tip {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;

    color: #697077;
}
.Vector {
    width: 93px;
    height: 60px;
    margin: 32px 0 9px 0;
}
/deep/ .el-upload--text {
    width: 100%;
    height: 193px;
    border: none;
}
/deep/ .el-upload-dragger {
    width: 100%;
    height: 193px;
}

.v_buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 162px;
    height: 48px;
    background: #91d9f2;
    border: 2px solid #91d9f2;
    border-radius: 8px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #ffffff;
}

/deep/ .v_dol .el-dialog {
    background: #ffffff;
    padding: 24px;
    border: 1px solid #dde1e6;
    border-radius: 16px;
}

/deep/ .v_dol .el-dialog .el-dialog__header {
    padding: 0;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
/deep/ .v_dol .el-dialog__headerbtn {
    position: relative;
    top: 0;
    right: 0;
}
/deep/ .v_dol .el-dialog__close {
    font-size: 18px;
    color: #21272a;
}
/deep/ .v_dol .el-dialog__title {
    color: #21272a;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
}
/deep/ .v_dol .el-dialog__body {
    padding: 0;
}
/deep/ .v_dol .el-input__inner {
    height: 48px;
    padding: 12px 16px;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
    border-radius: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #697077;
}
/deep/ .el-table thead {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #121619;
}
/deep/ .el-table {
    font-weight: 400;
    font-size: 12px;
    color: #121619;
}
/deep/ .el-table .el-table__cell {
    border: none;
}
.mr12 {
    margin-right: 12px;
}
/deep/ .flexCenter .el-input {
    width: 387px;
}
/deep/ el-input::-webkit-input-placeholder {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #ababab;
}
/deep/ .flexCenter .el-input .el-input__inner {
    background: #ffffff;
    border: 1px solid #16307c;
    border-radius: 4px;
    font-weight: 400;
    font-size: 16px;
    color: #121619;
    width: 100%;
    height: 35px;
    background: url('../../assets/img/search-outline.png') no-repeat 8px center;
    background-size: 24px;
    padding-left: 40px;
}
.Single {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 14px;
}
.mb24 {
    margin-bottom: 24px;
    display: inline-block;
}
.mb8 {
    margin-bottom: 8px;
}
.common {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 100%;

    color: #333333;
}
.u_shadow {
    width: 329px;
    padding: 20px 16px;
    background: #ffffff;
    box-shadow: 1px 3px 8px rgba(22, 48, 124, 0.16);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
}
.u_general_red_envelope_amount {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    /* identical to box height, or 16px */

    letter-spacing: 0.005em;

    color: #333333;
    margin-bottom: 16px;
}
.get_general_red_envelope_amount {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 100%;
    letter-spacing: 0.01em;
    color: #333333;
    text-align: right;
}
.input-file {
    display: none;
}
</style>
